import getField from '@form/formGenerator'

export const permissionSubjectSaveUrl = `${import.meta.env.VITE_API_URL}/api/permission-subjects`

export const permissionSubjectFormObject = {
  id: null,
  class: null
}

export const permissionSubjectFormFields = (permissionSubjectFormObject, updateFormObject, saveForm, errors, isLoading, t) => {
  const fields = [
    {
      type: 'text',
      name: 'module',
      label: t('labels.permission_subject'),
      value: permissionSubjectFormObject.module,
      key: 'permissionSubjectFormObject-module',
      cssClass: 'column is-12'
    },
    {
      type: 'button',
      buttons: true,
      callback: saveForm,
      cancel: false,
      validateText: t('actions.save'),
      cssClassParent: 'column is-12',
      cssClassValidate: 'button is-blue',
      validateIcon: 'icon-done',
      key: 'permissionSubjectFormObject-form',
      isLoading
    },
    {
      type: 'hidden',
      name: 'id',
      value: parseInt(permissionSubjectFormObject.id),
      key: 'permissionSubjectFormObject-id'
    }
  ]
  return fields.map(function (field) {
    return getField({ ...field, error: errors[field.name] ? errors[field.name].errors : '' }, updateFormObject)
  })
}